import { Badge } from 'reactstrap';
import {
  getBadgeColorVisitStatusAdapter,
  getVisitStatusAdapter,
} from '../../pages/properties/adapters/visitsAdapter';

interface Props {
  status: string;
  className?: string;
}

const RentSecondaryVisitBadge = ({ status, className = 'badge-lg' }: Props) => {
  return (
    <Badge
      className={className}
      color={getBadgeColorVisitStatusAdapter(status)}
    >
      {getVisitStatusAdapter(status)}
    </Badge>
  );
};

export default RentSecondaryVisitBadge;
